import React from 'react'

const TableBox = ({ topCategories = [], rowSpan }) => {
  return (
    <div className={`bg-white flex shadow-lg dark:bg-darkbg4 border border-gray-300 rounded-md overflow-y-auto h-full ${rowSpan}`}>
      <table className="min-w-full table-auto divide-y divide-gray-200">
        <thead className="sticky top-0 z-0">
          <tr>
            <th className="dark:bg-gray-800 dark:text-gray-400 px-6 py-2.5 bg-gray-100 text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Scope
            </th>
            <th className="dark:bg-gray-800 dark:text-gray-400 px-6 py-2.5 bg-gray-100 text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Category
            </th>
            <th className="dark:bg-gray-800 dark:text-gray-400 px-6 py-2.5 bg-gray-100 text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Tonnes CO2e
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {topCategories.length > 0 ? (
            topCategories.map((cat, index) => (
              <tr key={index} className="dark:bg-darkbg4 hover:bg-gray-50 dark:hover:bg-gray-600 dark:text-white">
                <td className="px-6 py-2.5 text-sm">{cat.scope}</td>
                <td className="px-6 py-2.5 text-sm">{cat.name}</td>
                <td className="px-6 py-2.5 text-sm text-green-500">
                  {Number(cat.total).toFixed(2)}
                </td>
              </tr>
            ))
          ) : (
            <tr className="dark:bg-darkbg4 hover:bg-gray-50 dark:hover:bg-gray-600 dark:text-white">
              <td colSpan="3" className="px-6 py-2.5 text-sm text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TableBox
